<div class="row form-primary-actions sticky-add-btn mt-3">
  <div class="col-12 text-center" id="showButtons">
    <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('generate')">Generate ABHA<i
    class="fa fa-check ml-2" aria-hidden="true"></i></button>
    @if (authenticationService.getUserType() != 'patient') {
      <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('link')">Link ABHA<i
      class="fa fa-check ml-2" aria-hidden="true"></i></button>
    }
    @if (authenticationService.getUserType() != 'patient') {
      <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('verify')">Verify ABHA<i
      class="fa fa-check ml-2" aria-hidden="true"></i></button>
    }
    @if (authenticationService.getUserType() != 'patient') {
      <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('print')">Print ABHA<i
      class="fa fa-check ml-2" aria-hidden="true"></i></button>
    }
    @if (authenticationService.getUserType() != 'patient') {
      <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('deLink')">De-Link ABHA<i
      class="fa fa-check ml-2" aria-hidden="true"></i></button>
    }
  </div>
</div>
